import React, { useState } from 'react';

// Semi-production test users - Star Wars characters for testing
const SEMI_PROD_USERS: Record<string, any> = {
  GCN9EXAMPLE1WALLET1ADDRESS1HARBL: {
    id: 'semi-user-1',
    piUserId: 'harbl-pi-user',
    piWalletAddress: 'GCN9EXAMPLE1WALLET1ADDRESS1HARBL',
    displayName: 'Luke Skywalker',
    username: 'luke_skywalker',
    isNewUser: false,
    stats: {
      totalGamesPlayed: 12,
      totalWins: 8,
      currentStreak: 3,
    },
  },
  GCN9EXAMPLE2WALLET2ADDRESS2WIFE: {
    id: 'semi-user-2',
    piUserId: 'wife-pi-user',
    piWalletAddress: 'GCN9EXAMPLE2WALLET2ADDRESS2WIFE',
    displayName: 'Princess Leia',
    username: 'princess_leia',
    isNewUser: false,
    stats: {
      totalGamesPlayed: 8,
      totalWins: 5,
      currentStreak: 2,
    },
  },
  GCN9EXAMPLE3WALLET3ADDRESS3FRIEND1: {
    id: 'semi-user-3',
    piUserId: 'friend1-pi-user',
    piWalletAddress: 'GCN9EXAMPLE3WALLET3ADDRESS3FRIEND1',
    displayName: 'Han Solo',
    username: 'han_solo',
    isNewUser: false,
    stats: {
      totalGamesPlayed: 15,
      totalWins: 9,
      currentStreak: 1,
    },
  },
  GCN9EXAMPLE4WALLET4ADDRESS4FRIEND2: {
    id: 'semi-user-4',
    piUserId: 'friend2-pi-user',
    piWalletAddress: 'GCN9EXAMPLE4WALLET4ADDRESS4FRIEND2',
    displayName: 'Obi-Wan Kenobi',
    username: 'obi_wan',
    isNewUser: false,
    stats: {
      totalGamesPlayed: 6,
      totalWins: 3,
      currentStreak: 0,
    },
  },
};

interface SemiProdAuthProps {
  showWalletModal: boolean;
  setShowWalletModal: (show: boolean) => void;
  loading: boolean;
  error: string | null;
  onAuthenticate: (walletAddress: string) => void;
}

const SemiProdAuth: React.FC<SemiProdAuthProps> = ({
  showWalletModal,
  setShowWalletModal,
  loading,
  error,
  onAuthenticate,
}) => {
  const [selectedCharacter, setSelectedCharacter] = useState<string | null>(
    null
  );

  const handleWalletSubmit = () => {
    if (!selectedCharacter) {
      return;
    }
    onAuthenticate(selectedCharacter);
  };

  if (!showWalletModal) {
    return null;
  }

  return (
    <div className="modal-overlay" onClick={() => setShowWalletModal(false)}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>🌟 Choose Your Character</h3>
          <button
            className="modal-close"
            onClick={() => setShowWalletModal(false)}
          >
            ×
          </button>
        </div>

        <div className="modal-body">
          <p>Select a Star Wars character to play as:</p>

          <div className="character-selection">
            {Object.entries(SEMI_PROD_USERS).map(([walletAddress, user]) => (
              <button
                key={walletAddress}
                className={`character-btn ${selectedCharacter === walletAddress ? 'selected' : ''}`}
                onClick={() => setSelectedCharacter(walletAddress)}
              >
                <div className="character-avatar">
                  {user.displayName === 'Luke Skywalker' && '⚔️'}
                  {user.displayName === 'Princess Leia' && '👑'}
                  {user.displayName === 'Han Solo' && '🚀'}
                  {user.displayName === 'Obi-Wan Kenobi' && '🧙‍♂️'}
                </div>
                <div className="character-info">
                  <div className="character-name">{user.displayName}</div>
                  <div className="character-stats">
                    {user.stats?.totalWins || 0} wins,{' '}
                    {user.stats?.totalGamesPlayed || 0} games
                  </div>
                </div>
              </button>
            ))}
          </div>

          {error && <div className="modal-error">{error}</div>}
        </div>

        <div className="modal-footer">
          <button
            onClick={() => setShowWalletModal(false)}
            className="btn-secondary"
            disabled={loading}
          >
            Cancel
          </button>
          <button
            onClick={handleWalletSubmit}
            className="btn-primary"
            disabled={loading || !selectedCharacter}
          >
            {loading ? (
              <>
                <div className="spinner"></div>
                Authenticating...
              </>
            ) : (
              'Authenticate'
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SemiProdAuth;
